var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIcCheck16Dp = function SvgIcCheck16Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.013 9.806l7.381-7.583L15 3.873l-8.987 9.233L1 7.956l1.606-1.65z"
  })));
};

export default "/_next/static/ic_check_16dp-338e67a2f899acff1e6492edc013b580svg";
export { SvgIcCheck16Dp as ReactComponent };